
/**
 * 콘텐츠 타입
 */
export type CourseDraftLocalizedSectionsItemLecturesItemContentType = typeof CourseDraftLocalizedSectionsItemLecturesItemContentType[keyof typeof CourseDraftLocalizedSectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftLocalizedSectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  INTERACTIVE: 'INTERACTIVE',
  QUIZ: 'QUIZ',
} as const;
